const adminConstants = {
  TOGGLE_PAYMENT_VIEW: 'TOGGLE_PAYMENT_VIEW',
};

export default adminConstants;
